module.exports = __webpack_public_path__ + "pc/img/acc-off.3fa223fe.svg";